var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime-corejs2/core-js/object/define-property", "@babel/runtime-corejs2/core-js/object/define-properties", "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors", "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor", "@babel/runtime-corejs2/core-js/object/get-own-property-symbols", "core-js/modules/es6.regexp.to-string", "core-js/modules/es6.date.to-string", "core-js/modules/es6.object.to-string", "@babel/runtime-corejs2/core-js/reflect/construct", "@babel/runtime-corejs2/core-js/object/keys", "core-js/modules/es6.string.link", "@babel/runtime-corejs2/helpers/classCallCheck", "@babel/runtime-corejs2/helpers/createClass", "@babel/runtime-corejs2/helpers/assertThisInitialized", "@babel/runtime-corejs2/helpers/inherits", "@babel/runtime-corejs2/helpers/possibleConstructorReturn", "@babel/runtime-corejs2/helpers/getPrototypeOf", "@babel/runtime-corejs2/helpers/defineProperty", "react", "prop-types", "classnames", "../../Tracking", "../../../../i18nHelpers", "../../css"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime-corejs2/core-js/object/define-property"), require("@babel/runtime-corejs2/core-js/object/define-properties"), require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"), require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"), require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"), require("core-js/modules/es6.regexp.to-string"), require("core-js/modules/es6.date.to-string"), require("core-js/modules/es6.object.to-string"), require("@babel/runtime-corejs2/core-js/reflect/construct"), require("@babel/runtime-corejs2/core-js/object/keys"), require("core-js/modules/es6.string.link"), require("@babel/runtime-corejs2/helpers/classCallCheck"), require("@babel/runtime-corejs2/helpers/createClass"), require("@babel/runtime-corejs2/helpers/assertThisInitialized"), require("@babel/runtime-corejs2/helpers/inherits"), require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"), require("@babel/runtime-corejs2/helpers/getPrototypeOf"), require("@babel/runtime-corejs2/helpers/defineProperty"), require("react"), require("prop-types"), require("classnames"), require("../../Tracking"), require("../../../../i18nHelpers"), require("../../css"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.defineProperties, global.getOwnPropertyDescriptors, global.getOwnPropertyDescriptor, global.getOwnPropertySymbols, global.es6Regexp, global.es6Date, global.es6Object, global.construct, global.keys, global.es6String, global.classCallCheck, global.createClass, global.assertThisInitialized, global.inherits, global.possibleConstructorReturn, global.getPrototypeOf, global.defineProperty, global.react, global.propTypes, global.classnames, global.Tracking, global.i18nHelpers, global.css);
    global.CollectionDescription = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _defineProperties, _getOwnPropertyDescriptors, _getOwnPropertyDescriptor, _getOwnPropertySymbols, _es6Regexp, _es6Date, _es6Object, _construct, _keys, _es6String, _classCallCheck2, _createClass2, _assertThisInitialized2, _inherits2, _possibleConstructorReturn2, _getPrototypeOf2, _defineProperty3, _react, _propTypes, _classnames, _Tracking, _i18nHelpers, _css) {
  "use strict";

  var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty2(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _defineProperties = _interopRequireDefault(_defineProperties);
  _getOwnPropertyDescriptors = _interopRequireDefault(_getOwnPropertyDescriptors);
  _getOwnPropertyDescriptor = _interopRequireDefault(_getOwnPropertyDescriptor);
  _getOwnPropertySymbols = _interopRequireDefault(_getOwnPropertySymbols);
  _construct = _interopRequireDefault(_construct);
  _keys = _interopRequireDefault(_keys);
  _classCallCheck2 = _interopRequireDefault(_classCallCheck2);
  _createClass2 = _interopRequireDefault(_createClass2);
  _assertThisInitialized2 = _interopRequireDefault(_assertThisInitialized2);
  _inherits2 = _interopRequireDefault(_inherits2);
  _possibleConstructorReturn2 = _interopRequireDefault(_possibleConstructorReturn2);
  _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf2);
  _defineProperty3 = _interopRequireDefault(_defineProperty3);
  _react = _interopRequireWildcard(_react);
  _propTypes = _interopRequireDefault(_propTypes);
  _classnames = _interopRequireDefault(_classnames);

  function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

  var trackingData = {};

  var CollectionDescription = /*#__PURE__*/function (_Component) {
    (0, _inherits2.default)(CollectionDescription, _Component);

    var _super = _createSuper(CollectionDescription);

    function CollectionDescription(props) {
      var _this;

      (0, _classCallCheck2.default)(this, CollectionDescription);
      _this = _super.call(this, props);
      (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "onReadMoreToggle", function () {
        _this.setState(function (prevState) {
          return {
            readMoreOpen: !prevState.readMoreOpen
          };
        });
      });
      (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "onAdditionalLinkClick", function () {
        var _this$props = _this.props,
            trackingTag = _this$props.trackingTag,
            trackingEnabled = _this$props.trackingEnabled;

        if (!trackingEnabled || !trackingData[trackingTag]) {
          return;
        }

        (0, _Tracking.send)(_objectSpread({
          target: null
        }, trackingData[trackingTag]));
      });
      _this.translate = (0, _i18nHelpers.translateMe)(props.labels);
      _this.state = {
        readMoreOpen: false
      };
      return _this;
    }

    (0, _createClass2.default)(CollectionDescription, [{
      key: "render",
      value: function render() {
        var _this$props2 = this.props,
            additionalLink = _this$props2.additionalLink,
            description = _this$props2.description,
            image = _this$props2.image,
            link = _this$props2.link,
            longDescription = _this$props2.longDescription,
            programCartridge = _this$props2.programCartridge,
            buttons = _this$props2.buttons;
        var readMoreOpen = this.state.readMoreOpen;
        var availableButtons = (0, _keys.default)(buttons).filter(function (key) {
          return buttons[key] !== null;
        });
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "next-collection-description"
        }, image && /*#__PURE__*/_react.default.createElement("div", {
          className: "next-collection-description__picture"
        }, /*#__PURE__*/_react.default.createElement("img", {
          "aria-hidden": "true",
          className: "next-collection-description__img",
          src: image.src,
          title: image.title,
          alt: image.title,
          width: "250"
        })), /*#__PURE__*/_react.default.createElement("div", {
          className: "next-collection-description__wrapper"
        }, link && /*#__PURE__*/_react.default.cloneElement(link, {
          className: 'next-collection-description__url'
        }), /*#__PURE__*/_react.default.createElement("div", {
          className: "next-collection-description__text"
        }, description), longDescription && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("button", {
          className: "next-collection-description__more",
          onClick: this.onReadMoreToggle
        }, readMoreOpen ? this.translate('readLess') : this.translate('readMore')), /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classnames.default)('next-collection-description__long-text', {
            'is-expanded': readMoreOpen
          })
        }, longDescription)), additionalLink && /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _css.showFor)('medium')
        }, /*#__PURE__*/_react.default.cloneElement(additionalLink, {
          className: 'next-collection-description__additional-url',
          onClick: this.onAdditionalLinkClick
        }))), (availableButtons.length || programCartridge) && /*#__PURE__*/_react.default.createElement("div", {
          className: "next-collection-description__infos"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classnames.default)('next-collection-description__buttons', {
            'next-collection-description__buttons--spaced': availableButtons.length && programCartridge
          })
        }, buttons.sharebar !== null && buttons.sharebar, buttons.subscribe !== null && buttons.subscribe), programCartridge), additionalLink && /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _css.hideFor)('medium')
        }, /*#__PURE__*/_react.default.cloneElement(additionalLink, {
          className: 'next-collection-description__additional-url',
          onClick: this.onAdditionalLinkClick
        })));
      }
    }]);
    return CollectionDescription;
  }(_react.Component);

  CollectionDescription.propTypes = {
    link: _propTypes.default.element,
    additionalLink: _propTypes.default.element,
    description: _propTypes.default.string.isRequired,
    image: _propTypes.default.shape({
      title: _propTypes.default.string.isRequired,
      src: _propTypes.default.string.isRequired
    }),
    labels: _propTypes.default.shape({
      readLess: _propTypes.default.string,
      readMore: _propTypes.default.string
    }),
    longDescription: _propTypes.default.string,
    programCartridge: _propTypes.default.node,
    buttons: _propTypes.default.shape({
      sharebar: _propTypes.default.node,
      subscribe: _propTypes.default.node
    }),
    trackingEnabled: _propTypes.default.bool,
    trackingTag: _propTypes.default.string
  };
  CollectionDescription.defaultProps = {
    buttons: {
      sharebar: null,
      subscribe: null
    },
    labels: {
      readLess: 'Read less',
      readMore: 'Read more'
    },
    programCartridge: null,
    trackingEnabled: false,
    trackingTag: null
  };
  var _default = CollectionDescription;
  _exports.default = _default;
});